import DeletePlaceDialog from './DeletePlaceDialog';

export default DeletePlaceDialog;
